import React from 'react';
import { Grid } from 'semantic-ui-react';

import FieldValue from 'components/FieldValue';
import validators, { isRequired } from 'forms/validators';
import {
    FertilizerEntityIds,
    FertilizerEventStartDate
} from 'services/fertilizerEvents/types';
import AppliedFertilizerEntitiesByDateRequest from 'scenes/Fertilizer/scenes/Diary/components/AppliedFertilizerEntitiesByDateRequest';
import { APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE } from 'services/appliedFertilizerEntitiesByDate/constants';
import { Field } from 'react-final-form';
import RenderDatePicker from 'forms/RenderDatePicker';
import FertilizerSchemaEntityTypeEntityDropdownField from './components/FertilizerSchemaEntityTypeEntityDropdownField';
import FertilizerSchemaInnerEntityTableField from './components/FertilizerSchemaInnerEntityTableField';
import FertilizerTotalAreaField from './components/FertilizerTotalAreaField';

interface Props {
    isEditing?: boolean;
}

export default function FertilizerEventSchedulePage(
    props: Props
): React.ReactElement {
    const { isEditing = false } = props;

    return (
        // TODO: CHANGE CSS CLASS??
        <Grid className="spray-event-modal-step">
            <FieldValue name="startDate">
                {(value: FertilizerEventStartDate): React.ReactElement => (
                    <AppliedFertilizerEntitiesByDateRequest
                        startDate={value}
                        namespace={
                            APPLIED_FERTILIZER_ENTITIES_BY_DATE_LOAD_NAMESPACE
                        }
                    />
                )}
            </FieldValue>
            <Grid.Row>
                <Grid.Column width="8">
                    <h4>Schedule details</h4>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="8">
                    <Field
                        name="startDate"
                        subscription={{
                            value: true,
                            touched: true,
                            error: true
                        }}
                        validate={isRequired}
                        component={RenderDatePicker as any}
                        label="Start date"
                        placeholder="Add start date"
                        dateFormat="EEE do MMM"
                        selectsStart
                    />
                </Grid.Column>
                <Grid.Column width="8">
                    <FieldValue name="startDate">
                        {(
                            startDate: FertilizerEventStartDate
                        ): React.ReactElement => (
                            <FertilizerSchemaEntityTypeEntityDropdownField
                                name="entityId"
                                validate={validators.isRequired}
                                disabled={isEditing || !startDate}
                            />
                        )}
                    </FieldValue>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="16">
                    <FieldValue name="fertilizerEntityIds">
                        {(value: FertilizerEntityIds): React.ReactElement => (
                            <FertilizerTotalAreaField entityIds={value} />
                        )}
                    </FieldValue>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width="16">
                    <FieldValue name="entityId">
                        <FertilizerSchemaInnerEntityTableField
                            name="fertilizerEntityIds"
                            validate={validators.hasLength}
                        />
                    </FieldValue>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
}
